import { CommonModule } from '@angular/common';
import { Component, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslatePipe } from '@core/pipes/translate.pipe';
import { TranslationService } from '@core/services/translation.service';
import { User } from '@modules/auth/models/login.interface';
import { AuthService } from '@modules/auth/services/auth.service';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { Popover } from 'primeng/popover';
import { SelectModule } from 'primeng/select';
import { TooltipModule } from 'primeng/tooltip';
import { SidebarService } from '../sidebar.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    RouterLinkActive,
    InputTextModule,
    ButtonModule,
    RouterLink,
    SelectModule,
    FormsModule,
    Popover,
    TooltipModule,
    TooltipModule,
    TranslatePipe,
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnInit {
  openItemIndex: number | null = null;
  userInitial = signal<string>('');
  userData = signal<User | null>({
    id: '',
    name: '',
    email: '',
    phone: null,
    isVerified: null,
    createdAt: '',
    updatedAt: '',
    workspaceId: '',
    roleId: '',
    role: undefined,
  });

  toggleAccordion(index: number): void {
    this.openItemIndex = this.openItemIndex === index ? null : index;
  }

  menuItems = [
    { icon: 'pi-chart-bar', labelKey: 'sidebar.dashboard', route: '/dashboard/analytics' },
    { icon: 'pi-folder', labelKey: 'sidebar.cases', route: '/cases' },
    { icon: 'pi-book', labelKey: 'sidebar.kycs', route: '/kycs' },
    { icon: 'pi-shield', labelKey: 'sidebar.pepSanctions', route: '/pep-sanctions' },
    { icon: 'pi-users', labelKey: 'sidebar.parties', route: '/parties' },
    { icon: 'pi-palette', labelKey: 'sidebar.templates', route: '/templates' },
    { icon: 'pi-cog', labelKey: 'sidebar.settings', route: '/settings' },
  ];

  constructor(
    public sidebarService: SidebarService,
    private authService: AuthService,
    public translateService: TranslationService,
  ) {}

  ngOnInit(): void {
    if (this.authService.getUser()) {
      this.userData.set(this.authService.getUser());
    }
  }

  getUserInitial() {
    const name = this.userData()?.name;
    if (!name) return '';

    return name
      .split(' ')
      .map((word) => word.charAt(0))
      .join('')
      .toUpperCase();
  }

  switchLang(lang: string) {
    this.translateService.setLanguage(lang);
  }

  onLogOut() {
    this.authService.logOut();
  }
}
